import React from 'react';
import PropTypes from 'prop-types';
import SvgText from '../svgText';
import './productID.styles.scss';

const ProductID = ({id}) => (
    <SvgText
        className="product-id"
        backgroundColor="rgb(0,0,0)"
        text={id}
        height="1.5rem"
        width="8rem"
        style={{
        }}
    />
);

ProductID.propTypes = {
    id: PropTypes.string,
};

export default ProductID;
